import { createContext, useContext, useEffect } from 'react';

/**
 * Lets a page suppress the site footer. Only the Offers "Coming Soon" template opts in
 * (§7.19: "No footer"); every other page leaves it on.
 */
export const HideFooterContext = createContext<(hide: boolean) => void>(() => {});

/** Hides the SiteFooter for as long as the current page is mounted. */
export function useHideFooter(): void {
  const setHideFooter = useContext(HideFooterContext);
  useEffect(() => {
    setHideFooter(true);
    return () => setHideFooter(false);
  }, [setHideFooter]);
}
